import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  giveAwayList: [],
};

export const giveAwayManageSlice = createSlice({
  name: "giveAwayManage",
  initialState,
  reducers: {
    giveAwayList: (state, action) => {
      state.giveAwayList = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { giveAwayList } = giveAwayManageSlice.actions;

export default giveAwayManageSlice.reducer;
